<template>
  <div class="mt-20">
    <Rightvideo />
    <Recent />
    <Categoriesplay />
    <Contactusvdo />
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import Rightvideo from "./components/Rightvideo.vue";
import Recent from "./components/Recent.vue";
import Categoriesplay from "./components/Categoriesplay.vue";
import Contactusvdo from "./components/Contactusvdo.vue";
import DownloadApp from "../home/components/DownloadApp.vue";
import Footer from "../Footer.vue";
export default {
  components: {
    Rightvideo,
    Recent,
    Categoriesplay,
    Contactusvdo,
    DownloadApp,
    Footer,
  },
};
</script>
